( ( $ ) => {

	const ajaxUrl = window.WPShopify.ajax_url;//window.ajaxurl || window.WPShopify.ajax_url || 'https://miniluxe.com/wp-admin/admin-ajax.php';//'https://newminiluxedev.wpengine.com/wp-admin/admin-ajax.php';//;'http://ml.test/wp-admin/admin-ajax.php'; 'http://ml.test/wp-admin/admin-ajax.php';//

	$( '[data-header-slider]' ).each( function initSlider( index, el ) {
		const $el = $( el );

		if ( $el.attr( 'data-should-load' ) ) {
			const post_id = $el.attr( 'data-should-load' );
			$.ajax( {
				method: 'GET',
				url: ajaxUrl,
				data: {
					action: 'ml_render_block',
					post_id: post_id,
					block_type: 'acf/header-slider',
					block_index: index,
					time: (new Date()).toISOString(),
				},

			} ).then( ( response ) => {
				const $updated = $( response.data );
				$el.replaceWith( $updated );
				initSlick( $updated );
			}, ( error ) => {
				console.warn( 'error loading ml_render_block', error );
				$el.slideUp( 300, ()=>{
					$el.remove();
				} );
			} )
		} else {
			initSlick( $el )
		}

	} );

	function initSlick( $el ) {
		const $slick = $( '[data-slides-wrapper]', $el );
		const $dots = $( '[data-dots-wrapper]', $el );


		$slick.slick( {
			autoplay: true,
			autoplaySpeed: 7000,
			slidesToShow: 1,
			slidesToScroll: 1,
			dots: true,
			arrows: false,
			fade: true,
			appendDots: $dots
		} );
	}

} )( jQuery )